<template>
	<div class="tab-wrapper">
		<div class="tab-contents">
			<div
				v-for="(value, key) in objectdata.tabs"
				:key="key"
				class="tab-content--bg animated"
				:data-bg-item="(key + 1)"
				:style="'background-image:url(' + value.tabbackgroundimage+ ')'"
			/>
			<div class="content-wrapper">
				<div class="tab-content--wrapper">
					<div
						v-for="(value, key) in objectdata.tabs"
						:key="key"
						:id="'tabcontent-'+ (key + 1)"
						class="tab-content"
					>
						<div class="tab-content--slogan animated delay-025s">
							<img :src="value.tabsloganimage" alt="slogan">
							<!-- <a href="#" class="btn btn-circle"><span>Mehr entdecken</span></a> -->
						</div>
						<div class="tab-content--image animated delay-05s">
							<img :src="value.tabproductimage" alt>
						</div>
						<div class="tab-content--info animated delay-075s">
							<div
								class="headline"
								v-if="getHeadline(value.headline.unit, value.headline.value)"
								v-html="getHeadline(value.headline.unit, value.headline.value)"
							/>
							<p v-html="value.text"/>
							<a href="#" class="btn btn-circle">
								<span>Mehr entdecken</span>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="tab-navigation">
			<button
				v-for="(value, key) in objectdata.tabs"
				:key="key"
				:id="'tablink-'+ (key +1)"
				class="tab-links"
				:data-tab-item="(key + 1)"
			>
				<img :src="value.tabimage" :alt="value.tabtext">
				<h5>{{value.tabtext}}</h5>
			</button>
		</div>
		<!--div
			class="headline"
			v-if="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
		/>
		<div class="text" v-html="objectdata.text"/>
		<img class="tabproductimage" :src="objectdata.tabproductimage">
		<img class="tabsloganimage" :src="objectdata.tabsloganimage">
		<img class="tabbackgroundimage" :src="objectdata.tabbackgroundimage">
		<img class="tabimage" :src="objectdata.tabimage">
		<div class="tabtext" v-html="objectdata.tabtext"/-->
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {},
		mounted() {
			this.initTabsAnimation();
		},
		methods: {
			initTabsAnimation() {
				let elemsTab = document.querySelectorAll(
					".tab-navigation .tab-links"
				);
				let animationDelay = 900;

				this.openFirst(1, animationDelay);

				[].forEach.call(elemsTab, el => {
					el.addEventListener("click", event => {
						if (
							!event.toElement.parentNode.classList.contains(
								"js-active"
							)
						) {
							let currentTabItem = event.toElement.parentNode.getAttribute(
								"data-tab-item"
							);
							this.animateTabContentOut();
							setTimeout(() => {
								this.animateTabContentIn(
									currentTabItem,
									animationDelay
								);
							}, 900);
							setTimeout(() => {
								this.animateTabBackground(
									currentTabItem,
									animationDelay
								);
							}, 1200);
						}
					});
				});
			},
			openFirst(p_tabItem, p_animationDelay) {
				let delay = p_animationDelay;
				setTimeout(() => {
					this.animateTabContentIn(p_tabItem, delay);
				}, 600);
				setTimeout(() => {
					this.animateTabBackground(p_tabItem, delay);
				}, 900);
			},
			animateTabBackground(p_tabLinkItem, p_animationDelay) {
				let classBgAnimateIn = "fadeIn";
				let classBgAnimateOut = "fadeOut";
				// fadeout all backgrounds
				let allTabContents = document.querySelectorAll(
					"div[id*=tabcontent-]"
				);
				let allTabBackgrounds = document.querySelectorAll(
					".tab-content--bg.animated." + classBgAnimateIn
				);
				[].forEach.call(allTabContents, elCon => {
					elCon.classList.remove("js-active");
				});
				this.clearAllTabs(p_animationDelay);
				// show current Tab and Background
				let currentTabElem = document
					.querySelector("#tabcontent-" + p_tabLinkItem)
					.getBoundingClientRect();
				let currentTabElemHeight = currentTabElem.height;

				document.querySelector(".tab-content--wrapper").style.height =
					currentTabElemHeight + "px";
				document.querySelector(".tab-contents").style.height =
					currentTabElemHeight + "px";
				document
					.querySelector("#tabcontent-" + p_tabLinkItem)
					.classList.add("js-active");
				//fade bg out
				[].forEach.call(allTabBackgrounds, elBg => {
					elBg.classList.add(classBgAnimateOut);
				});
				// fade bg in
				document
					.querySelector(
						'.tab-content--bg[data-bg-item="' + p_tabLinkItem + '"]'
					)
					.classList.add(classBgAnimateIn);
			},
			animateTabContentOut() {
				let classAnimateOut = "fadeOutLeftBig";
				let allActiveElemens = document.querySelectorAll(
					".tab-content .animated.fadeInRightBig"
				);
				[].forEach.call(allActiveElemens, el => {
					el.classList.add(classAnimateOut);
				});
			},
			animateTabContentIn(p_tabLinkItem, p_delay) {
				let classAnimateIn = "fadeInRightBig";
				// clear old animation-classes
				// setTimeout(() => {
				let allCurrentContent = document.querySelectorAll(
					"#tabcontent-" + p_tabLinkItem + "> .animated"
				);
				[].forEach.call(allCurrentContent, elCon => {
					elCon.classList.add(classAnimateIn);
				});
				// }, p_delay);
			},
			clearAllTabs(p_animationDelay) {
				let delay = p_animationDelay + 100;
				setTimeout(() => {
					let allOutfadedBackgrounds = document.querySelectorAll(
						".tab-content--bg.animated.fadeIn.fadeOut"
					);
					[].forEach.call(allOutfadedBackgrounds, el => {
						el.classList.remove("fadeIn", "fadeOut");
					});
				}, delay);
				let allOutfadedContents = document.querySelectorAll(
					".animated.fadeInRightBig.fadeOutLeftBig"
				);
				[].forEach.call(allOutfadedContents, el => {
					el.classList.remove("fadeInRightBig", "fadeOutLeftBig");
				});
			}
		},
		composed: {}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	// Tabs
	.tab-wrapper {
		margin-bottom: 80px;

		button {
			background: transparent;
			border: none;
			cursor: pointer;
			padding: 0 10px;

			&:focus {
				outline: none;
			}
		}
	}

	.tab-navigation {
		// clear: left;
		display: flex;
		margin: 0 auto;
		width: 100%;
		max-width: $maxwidth-content;

		.tab-links {
			flex: 1;

			h5 {
				color: $color-green-light;
				font-size: inherit;
				transition: color 0.2s ease-in-out;
			}

			img {
				height: auto;
				width: 100%;
				max-width: 150px;
			}

			&.js-active,
			&:hover {
				h5 {
					color: $color-green;
				}
			}
		}
	}

	.tab-contents {
		height: 340px;
		position: relative;
		padding-bottom: 0;
		overflow: hidden;
		transition: height 1s ease-in-out;

		.tab-content--wrapper {
			overflow: hidden;
			position: relative;
			width: 100%;
			max-width: none;
		}

		.tab-content--bg {
			background-size: cover;
			background-repeat: no-repeat;
			background-position: left -40px center;
			bottom: 0;
			opacity: 0;
			// height: 0;
			// display: none;
			left: 0;
			position: absolute;
			right: 0;
			top: 0;
			// transition: opacity .5s ease-in-out;

			@include min-screen($screen-min-m) {
				background-size: 100% 100%;
				background-position: center center;
			}
		}

		.tab-content {
			align-items: center;
			background-size: 100% 100%;
			background-repeat: no-repeat;
			background-position: center center;
			display: flex;
			float: left;
			opacity: 0;
			top: 0;
			// display: none;
			// height: 0;
			position: absolute;
			width: 100%;
			// transition: height 1.5s ease-in-out;
			width: 100%;
			z-index: -1;

			// &:nth-of-type(2):not(.js-active) {
			// 	transform: translateX(-100%);
			// }

			// &:nth-of-type(3):not(.js-active) {
			// 	transform: translateX(-200%);
			// }

			&.js-active {
				height: auto;
				opacity: 1;
				transform: translateX(0);
				z-index: 1;
				// display: block;
			}

			> div {
				flex: 1;
				flex-direction: column;
				text-align: center;
				flex-grow: 0.7;
				opacity: 0;
				padding: 0 10px;

				&:nth-of-type(2) {
					flex-grow: 0.3;
				}

				@include min-screen($screen-min-m) {
					flex-grow: 0.3;

					&:nth-of-type(2) {
						flex-grow: 0.2;
					}

					&:nth-of-type(3) {
						flex-grow: 0.5;
					}
				}
			}

			.tab-content--slogan {
				img {
					width: 100%;
				}
			}

			.tab-content--image {
				img {
					max-width: 80px;
				}
			}

			.tab-content--info {
				display: none;

				@include min-screen($screen-min-m) {
					color: $color-white;
					display: block;
					text-align: left;

					h4 {
						color: $color-white;
						display: block;
						margin: 40px 0 16px;
						padding: 0;

						&:after {
							border: none;
							content: "";
						}
					}
				}
			}
		}
	}
</style>